import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageComponent } from './landing-page.component';
import { ObjetivoComponent } from './objetivo/objetivo.component';
import { GestionComponent } from './gestion/gestion.component';
import { HistoriaComponent } from './historia/historia.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { TramitesComponent } from './tramites/tramites.component';
import { PlanoComponent } from './plano/plano.component';
import { AppsComponent } from './apps/apps.component';
import { ContactoComponent } from './contacto/contacto.component';
import { PrincipalComponent } from './principal/principal.component';
import { RegistroTotalComponent } from './registro-total/registro-total.component';
import { NoticiasComponent } from './noticias/noticias.component';
import { MostrarNoticiaComponent } from './noticias/mostrar-noticia/mostrar-noticia.component';
import { RestorePasswordComponent } from './restore-password/restore-password.component';
import { PreguntasFrecuentesComponent } from './preguntas-frecuentes/preguntas-frecuentes.component';
import { AvisoLegalComponent } from './aviso-legal/aviso-legal.component';
import { PoliticaPrivacidadComponent } from './politica-privacidad/politica-privacidad.component';
import { PoliticaCookiesComponent } from './politica-cookies/politica-cookies.component';


const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: PrincipalComponent
      },
      {
        path: 'objetivo',
        component: ObjetivoComponent
      },
      {
        path: 'gestion',
        component: GestionComponent
      },
      {
        path: 'historia',
        component: HistoriaComponent
      },
      {
        path: 'preguntas-frecuentes',
        component: PreguntasFrecuentesComponent
      },
      {
        path: 'usuarios',
        component: UsuariosComponent
      },
      {
        path: 'tramites',
        component: TramitesComponent
      },
      {
        path: 'plano',
        component: PlanoComponent
      },
      {
        path: 'apps',
        component: AppsComponent
      },
      {
        path: 'contacto',
        component: ContactoComponent
      },
      {
        path: 'registro-usuario-publico',
        component: RegistroTotalComponent
      },
      {
        path: 'noticias',
        component: NoticiasComponent
      },
      {
        path: 'mostrar-noticia/:id',
        component: MostrarNoticiaComponent
      },
      {
        path: 'restaurar-contrseña/:cod',
        component: RestorePasswordComponent
      },
      {
        path: 'aviso-legal',
        component: AvisoLegalComponent
      },
      {
        path: 'politica-privacidad',
        component: PoliticaPrivacidadComponent
      },
      {
        path: 'politica-cookies',
        component: PoliticaCookiesComponent
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LandingPageRoutingModule { }
